export const RemoveIcon = (props) => {
    const { width = 24, height = 24, className = '' } = props;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            class={className}
            height={height}
            fill="none"
            focusable="false"
            aria-hidden="true"
            viewBox="0 0 24 24"
        >
            <circle cx="12" cy="12" r="12" fill="currentColor" />
            <path
                fill="#fff"
                d="M17.85 11.44c-.01.01-1.22.02-2.69.02-3.32 0-3.94.02-6.82.18a277.44 277.44 0 0 1-3.71.21c-.3.03-.5.1-.5.18 0 .06.08.15.12.15l.07.02.1.02.29.09c.72.23 1.9.34 4.2.4a111.4 111.4 0 0 1 4.95.2c3.15.19 3.64.21 4.33.21.35 0 .41 0 .53-.03.16-.04.42-.15.6-.27.25-.15.5-.42.5-.52a.2.2 0 0 1 .03-.06.37.37 0 0 0 0-.27c-.05-.1-.18-.2-.47-.33-.44-.2-.4-.2-1-.2h-.53Z"
            />
        </svg>
    );
};
